"use client";

import { Response } from "@/components/ai-elements/response";
import type { MessageRenderGroup, MessageViewPhase } from "./render-model";

/** 最終回答として確定した連続 text part を描画する。 */
export function AnswerGroup({
  group,
  phase,
}: {
  group: Extract<MessageRenderGroup, { kind: "answer" }>;
  phase: MessageViewPhase;
}) {
  return group.parts.map(({ part, partIndex }) => (
    <Response
      className="max-w-none"
      isAnimating={phase === "live"}
      key={`answer-${partIndex}`}
    >
      {part.text}
    </Response>
  ));
}
